import React from "react";
import CommissionSalesGroupsPageGen from "./generated/CommissionSalesGroupsPageGen";
import commissionSalesGroupsService from "../../../services/legacy/commissionSalesGroupsService";

const SHOW_IN_GRID = new Set(["groupid", "name"]);
const SHOW_IN_FILTER = new Set(["groupid", "name"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const CommissionSalesGroupsPage = () => {
  const service = commissionSalesGroupsService;
  return <CommissionSalesGroupsPageGen service={service} transformColumns={transformColumns} />;
};

export default CommissionSalesGroupsPage;